/* YNS free bundle gifts
   Keeps the free bonus items in the cart in sync with the bundles in it:
   - CORE Bundle       -> ECG & Dysrhythmia Interpretation guide
   - FastTrack Bundle  -> ECG guide + Critical Care Nursing Medications Flashcards
   Gift lines carry the hidden property _yns_gift and are priced at $0 by the matching
   automatic Buy X Get Y discounts in Shopify admin. Rules come from window.YNS_GIFTS
   (snippets/yns-free-gifts.liquid). */
(function () {
  'use strict';
  var C = window.YNS_GIFTS;
  if (!C || !C.rules || !window.fetch) return;

  var busy = false;
  var again = false;

  function isGift(line) {
    return line.properties && line.properties._yns_gift;
  }

  function sectionIds() {
    return document.querySelector('cart-drawer') ? 'cart-drawer,cart-icon-bubble' : 'cart-icon-bubble';
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-YNS-Gift': '1' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error(url + ' ' + r.status);
      return r.json();
    });
  }

  function wantedGifts(cart) {
    var products = {};
    cart.items.forEach(function (l) {
      if (!isGift(l)) products[l.product_id] = true;
    });
    var want = {};
    C.rules.forEach(function (rule) {
      if (products[rule.trigger]) rule.gifts.forEach(function (v) { want[v] = true; });
    });
    return want;
  }

  function parse(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  function refresh(res) {
    if (/^\/cart\/?$/.test(location.pathname)) {
      location.reload();
      return;
    }
    var s = (res && res.sections) || {};
    if (s['cart-drawer']) {
      var next = parse(s['cart-drawer'], '#CartDrawer');
      var cur = document.querySelector('#CartDrawer');
      if (next && cur) cur.innerHTML = next.innerHTML;
      var drawer = document.querySelector('cart-drawer');
      if (drawer) {
        drawer.classList.remove('is-empty');
        var overlay = drawer.querySelector('#CartDrawer-Overlay');
        if (overlay && drawer.close) overlay.addEventListener('click', drawer.close.bind(drawer));
      }
    }
    if (s['cart-icon-bubble']) {
      var bubble = parse(s['cart-icon-bubble'], '.shopify-section');
      var icon = document.getElementById('cart-icon-bubble');
      if (bubble && icon) icon.innerHTML = bubble.innerHTML;
    }
  }

  function sync() {
    if (busy) { again = true; return; }
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var want = wantedGifts(cart);
        var have = {};
        var updates = {};
        var changed = false;

        // The shopper already added the gift product themselves: don't add a second copy
        // (the Buy X Get Y discount makes that line free).
        cart.items.forEach(function (l) {
          if (!isGift(l) && want[l.variant_id]) have[l.variant_id] = true;
        });

        cart.items.forEach(function (l) {
          if (isGift(l)) {
            if (!want[l.variant_id] || have[l.variant_id]) { updates[l.key] = 0; changed = true; }
            else if (l.quantity !== 1) { updates[l.key] = 1; changed = true; }
            have[l.variant_id] = true;
          }
        });

        var toAdd = Object.keys(want)
          .filter(function (v) { return !have[v]; })
          .map(function (v) { return { id: Number(v), quantity: 1, properties: { _yns_gift: 'Free bonus' } }; });

        var step = Promise.resolve(null);
        if (changed) step = step.then(function () { return post('/cart/update.js', { updates: updates, sections: sectionIds() }); });
        if (toAdd.length) step = step.then(function () { return post('/cart/add.js', { items: toAdd, sections: sectionIds() }); });
        return step.then(function (res) { if (res) refresh(res); });
      })
      .catch(function (e) { console.warn('[YNS gifts]', e); })
      .then(function () {
        busy = false;
        if (again) { again = false; sync(); }
      });
  }

  // Any cart change made by other scripts (product form, add-on pickers, cart drawer) re-checks the gifts.
  // Our own requests carry X-YNS-Gift so they do not loop.
  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var req = nativeFetch.apply(this, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var own = init && init.headers && init.headers['X-YNS-Gift'];
      if (!own && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
        req.then(function () { setTimeout(sync, 60); }, function () {});
      }
    } catch (e) {}
    return req;
  };

  function start() {
    sync();
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { sync(); });
    }
    document.addEventListener('cart:item-added', function () { sync(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
